import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=b9dc5068&scoped=true&"
var script = {}
import style0 from "./navbar.scss?vue&type=style&index=0&id=b9dc5068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9dc5068",
  null
  
)

export default component.exports